<template>
  <div :class="[$style.outer, 'zy_form']">
    <el-form
      v-show="showAll"
      :model="value" 
      size="small" 
      ref='form'
      v-bind="{
        inline: true,
        ...formProps
      }"
    >
      <el-form-item
        v-for="(item, index) in options"
        v-permission="item.permission"
        v-per="item.per"
        :key="item.prop + '' + index"
        :label="item.label"
        :rules="item.rules"
        :prop="item.prop"
        class="mr20"
        v-show="isShowMore ? true : index < 6"
        >
        <!-- :class="index === (options.length - 1) && btnInline ? 'mr20' : 'mr20'" -->
        <component
          v-if="item.type === 'component'"
          :is="item.is"
          v-model="value[item.prop]"
          :form="value"
          :item="item"
          v-bind="item.componentProps"
          :propOptions="item.propOptions"
          v-on="item.event"
        >
        </component>
        <el-select v-else-if="item.type === 'select'"
          v-on="item.event"
          v-model="value[item.prop]"
          v-bind="{
            placeholder: `请选择${inline ? '' : item.label}`,
            clearable: true,
            ...item.propOptions,
          }"
        >
          <el-option
            v-for="opt in item.options"
            :key="opt[item.valueMap || 'value'] || opt[item.labelMap || 'label']"
            :label="opt[item.labelMap || 'label']"
            :disabled="opt.disabled"
            :value="opt[item.valueMap || 'value']">
            {{ opt['showLabel'] || opt[item.labelMap || 'label'] }}
          </el-option>
        </el-select>
        <el-cascader
          v-else-if="item.type === 'cascader'"
          v-model="value[item.prop]"
          :options="item.options"
          v-on="item.event"
          v-bind="{
            placeholder: `请选择${inline ? '' : item.label}`,
            clearable: true,
            ...item.propOptions,
          }"
        ></el-cascader>
        <el-radio-group
          v-else-if="item.type === 'radio'"
          v-model="value[item.prop]"
          v-bind="item.propOptions"
          v-on="item.event"
        >
          <component
            :is="item.button ? `ElRadioButton` : `ElRadio`"
            v-for="opt in item.options"
            :key="opt[item.valueMap || 'value'] || opt[item.labelMap || 'label']"
            :label="opt[item.valueMap || 'value']"
            :disabled="opt.disabled"
          >
          {{ opt[item.labelMap || 'label'] }}
          </component>
        </el-radio-group>
        <el-checkbox-group
          v-else-if="item.type === 'checkbox'"
          v-model="value[item.prop]"
          v-bind="item.propOptions"
          v-on="item.event"
        >
          <component
            :is="item.button ? `ElCheckboxButton` : `ElCheckbox`"
            v-for="opt in item.options"
            :key="opt[item.valueMap || 'value'] || opt[item.labelMap || 'label']"
            :label="opt[item.valueMap || 'value']"
            :disabled="opt.disabled"
          >
          {{ opt[item.labelMap || 'label'] }}
          </component>
        </el-checkbox-group>
        <div v-else-if="item.type === 'date'">
          <el-date-picker
            v-model="value[item.prop]"
            v-bind="{
              placeholder: `请选择${item.label}`,
              valueFormat: 'yyyy-MM-dd',
              ...item.propOptions,
            }"
            v-on="item.event"
            :style="item.style || 'width: 180px;'"
          />
        </div>
        <div v-else-if="item.type === 'daterange'" :class="$style.flex">
          <el-date-picker
            v-model="value[item.propStart]"
            v-bind="{
              type: 'date',
              valueFormat: 'yyyy-MM-dd',
              style: 'width: 200px;',
              placeholder: '开始时期',
              ...item.options
            }"
            v-on="item.event"
          />
          <span :class="$style.mlr5">{{ item.connect || '至' }}</span>
          <el-date-picker
            v-model="value[item.propEnd]"
            v-bind="{
              type: 'date',
              valueFormat: 'yyyy-MM-dd',
              style: 'width: 200px;',
              placeholder: '结束时期',
              ...item.options
            }"
            v-on="item.event"
          />
        </div>
        <Department
          v-else-if="item.type === 'department'"
          :value.sync="value[item.prop]"
          v-bind="{
            ...item.propOptions,
          }"
        />
        <Upload
          v-else-if="item.type === 'upload'"
          v-model="value[item.prop]"
          :propOptions="item.propOptions"
          :btnText="item.btnText"
          @input="validateField(item.prop)"
        />
        <UploadImage
          v-else-if="item.type === 'uploadImage'"
          v-model="value[item.prop]"
          v-bind="item.propOptions"
          @input="validateField(item.prop)"
        />
        <PasteUpload
          v-else-if="item.type === 'pasteUpload'"
          v-model="value[item.prop]"
          :propOptions="item.propOptions"
          @input="validateField(item.prop)"
        />
        <slot v-else-if="item.type === 'slot'" :name="item.prop" :item="item"></slot>
        <el-input
          v-else
          v-model="value[item.prop]"
          v-bind="{
            placeholder: `请输入${inline ? '' : item.label}`,
            clearable: true,
            style: inline ? 'width: 150px;' : '',
            ...item.propOptions,
          }"
          v-on="item.event"
        >
        </el-input>
        <template v-if="item.append">
          <slot :name="`${item.prop}Append`" :item="item">
            <div class="red fs12">
              <i class="el-icon-warning fs14"></i>
              {{ item.append }}
            </div>
          </slot>
        </template>
      </el-form-item>
      <el-form-item v-if="!hideBtn && btnInline">
        <div class="zy_form_btns">
          <slot name="btns">
            <el-button @click="$emit('submit')">查询</el-button>
            <el-button @click="$emit('reset')">清空</el-button>
            <el-button @click="$emit('excel')">导出</el-button>
          </slot>
        </div>
      </el-form-item>
    </el-form>
    <div class="zy_form_btns" v-if="!hideBtn && !btnInline">
    <!-- <div :class="$style.left" class="clickText fs12 lh28" @click="showAll = !showAll"> {{ showAll ? '收起' : '展开'}}</div> -->
      <slot name="btns">
        <el-button @click="$emit('submit')">查询</el-button>
        <el-button @click="$emit('reset')">清空条件</el-button>
        <el-button @click="$emit('excel')">导出</el-button>
      </slot>
    </div>
    <el-button
      v-if="showMoreBtn"
      :class="$style.showMoreBtn"
      type="text"
      @click="isShowMore = !isShowMore"
    >
      {{ isShowMore ? "收起更多筛选" : "显示更多筛选" }}
      <i :class="isShowMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
    </el-button>
  </div>
</template>

<script>
import Department from "@/components/Department";
import Upload from "@/components/Upload";
import UploadImage from "@/components/form/UploadImage";
import PasteUpload from "@/components/PasteUpload";
export default {
  components: {
    Department,
    Upload,
    PasteUpload,
    UploadImage
  },
  props: {
    value: Object,
    options: {
      type: Array,
      default: () => []
    },
    formProps: Object,
    btnInline: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    showMoreBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showAll: true,
      isShowMore: true
    }
  },
  computed: {
    inline () {
      return !this.formProps || this.formProps.inline
    }
  },
  methods: {
    validate() {
      return new Promise((resolve, reject)=> {
        this.$refs['form'].validate(valid => {
          if (valid) {
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    validateField(props) {
      this.$refs['form'].validateField(props)
    },
    clearValidate(props) {
      this.$refs['form'].clearValidate(props)
    },
  }
}
</script>

<style lang='scss' module>
.flex {
  display: flex;
  align-items: center;
}
.mlr5 {
  margin: 0 5px;
}
.outer {
  position: relative;
}
.left {
  position: absolute;
}
.showMoreBtn {
  position: absolute;
  left: 20px;
  bottom: 15px;
}
</style>
<style lang='scss'>
.zy_form_btns {
  text-align: center;
  .el-button {
    padding: 7px 20px;
    // padding: 5px 20px;
  }
}
.zy_form .el-select--small.collapseTags {
  .el-input--small .el-input__inner {
    height: 25px!important;
  }
  .el-select__tags {
    flex-wrap: nowrap!important;
  }
}

</style>